const API_URL = process.env.REACT_APP_API_URL || 'https://payments.lawbee.net/api';
const API_KEY = process.env.REACT_APP_API_KEY || '';

export const checkUserExists = async (email) => {
  try {
    const response = await fetch(`${API_URL}/users/check?email=${encodeURIComponent(email)}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-API-Key': API_KEY
      },
      mode: 'cors',
      credentials: 'include'
    });
    
    if (!response.ok) {
      return { exists: false, error: 'Failed to check user existence' };
    }
    
    const data = await response.json();
    return {
      exists: data.exists || false,
      alreadyRegistered: data.alreadyRegistered || false
    };
  } catch (error) {
    return { exists: false, error: error.message };
  }
};

export const trackReferral = async (referrerId, userData) => {
  try {
    const response = await fetch(`${API_URL}/referrals/track`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-API-Key': API_KEY
      },
      mode: 'cors',
      credentials: 'include',
      body: JSON.stringify({
        referrerId,
        newUserEmail: userData.email,
        newUserName: userData.displayName,
        timestamp: new Date().toISOString(),
        referralType: 'subscription'
      }),
    });
    
    if (!response.ok) {
      if (response.status === 503) {
        try {
          const pendingReferrals = JSON.parse(localStorage.getItem('pendingReferrals') || '[]');
          pendingReferrals.push({
            referrerId,
            newUserEmail: userData.email,
            newUserName: userData.displayName,
            timestamp: new Date().toISOString(),
            referralType: 'subscription',
            status: 'pending_server_error',
            error: 'Server temporarily unavailable'
          });
          localStorage.setItem('pendingReferrals', JSON.stringify(pendingReferrals));
        } catch (localStorageError) {
          // Silent error handling
        }
        
        throw new Error('Server temporarily unavailable, please try again later');
      }
      
      try {
        const errorData = await response.json();
        
        if (errorData.selfReferral || (errorData.error && errorData.error.toLowerCase().includes('refer yourself'))) {
          throw new Error('Self-referrals are not permitted');
        }
        
        if (errorData.alreadyRegistered || (errorData.error && errorData.error.toLowerCase().includes('already registered'))) {
          throw new Error('This email is already registered with Lawbee');
        }
        
        throw new Error(errorData.error || 'Failed to track referral');
      } catch (parseError) {
        throw new Error('Failed to track referral');
      }
    }
    
    return await response.json();
  } catch (error) {
    try {
      const pendingReferrals = JSON.parse(localStorage.getItem('pendingReferrals') || '[]');
      pendingReferrals.push({
        referrerId,
        newUserEmail: userData.email,
        newUserName: userData.displayName,
        timestamp: new Date().toISOString(),
        referralType: 'subscription',
        error: error.message || 'Unknown error'
      });
      localStorage.setItem('pendingReferrals', JSON.stringify(pendingReferrals));
    } catch (localStorageError) {
      // Silent error handling
    }
    
    throw error;
  }
};

export const getReferrerInfo = async (referrerId) => {
  try {
    const response = await fetch(`${API_URL}/referrals/info?id=${encodeURIComponent(referrerId)}`, {
      method: 'GET',
      headers: {
        'X-API-Key': API_KEY,
        'Content-Type': 'application/json'
      },
      mode: 'cors',
      credentials: 'include'
    });
    
    if (!response.ok) {
      return {
        name: 'Lawbee User',
        email: 'user@lawbee.net',
        rewardAmount: 30,
        rewardType: 'subscription'
      };
    }
    
    const referrerData = await response.json();
    return {
      name: referrerData.name || 'Lawbee User',
      email: referrerData.email,
      rewardAmount: referrerData.rewardAmount || 30,
      rewardType: referrerData.rewardType || 'subscription'
    };
  } catch (error) {
    return {
      name: 'Lawbee User',
      email: 'user@lawbee.net',
      rewardAmount: 30,
      rewardType: 'subscription'
    };
  }
};